import React, { Component } from 'react'
import { Dispatch } from 'react-redux'
import { viewClass, toggleClass } from '~/services/api'
import { ClassDTO } from '~/model'
import { API_SUCCESS, API_FAILURE } from '~/helper/constant/api_status'
import * as Status from '~/helper/constant/status'
import * as route from '~/helper/constant/route'
import { toastMessage } from '~/helper/function/util'
import moment from 'moment'
import $ from 'jquery'

type Props = {
    token: String,
    dispatch: Dispatch<any>,
}

type State = {
    classes: Array,
    data: Array,
    loading: Boolean,
}

export class AbstractClassViewComponent extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            loading: false,
            data: [],
            classes: [
                {
                    class: {
                        field: 'text',
                        translate: "classes:classTitle",
                        route: false,
                        sortable: true,
                    },
                    code: {
                        field: 'text',
                        translate: "classes:class.codeLabel",
                        route: false,
                        sortable: true,
                    },
                    status: {
                        field: 'badge',
                        translate: "status",
                        route: false,
                        sortable: true,
                    },
                    section: {
                        field: 'button',
                        translate: "classes:section.title",
                        route: true,
                        sortable: false,
                    },
                    action: {
                        field: 'button',
                        translate: "classes:class.action",
                        route: true,
                        sortable: false,
                    },
                },
            ],
        }
        this._handleChange = this._handleChange.bind(this)
        this.toggle = this.toggle.bind(this)
    }

    componentDidMount() {
        this.loadClass()
    }

    _handleChange(key, data) {
        this.setState({ [key]: data })
    }

    toggle(e) {
        const link = e.target.getAttribute('link')
        $('#close_' + link).trigger('click')
        toggleClass(link, this.props.token).then((response) => {
            if (response.code == API_SUCCESS) {
                toastMessage('success', response.message)
                this.loadClass()
            } else {
                toastMessage('error', response.message)
            }
        })
    }

    loadClass() {
        this._handleChange('loading', true)
        viewClass(this.props.token).then((response) => {
            this._handleChange('loading', false)
            let classes = []
            classes.push(this.state.classes[0])
            let dataList = []
            if (response.code == API_SUCCESS) {
                response.data.class.map((item, index) => {
                    const data: ClassDTO = item
                    let text = null
                    if (data.status == Status.ACTIVE) {
                        text = {
                            text: 'Active',
                            translate: "statusActive",
                            badge: 'table-green',
                            modal: 'modal_class_' + index,
                        }
                    } else {
                        text = {
                            text: 'Inactive',
                            translate: "statusInactive",
                            badge: 'table-red',
                            modal: 'modal_class_' + index,
                        }
                    }
                    const tableData = {
                        class: {
                            text: data.name,
                        },
                        code: {
                            text: data.code,
                        },
                        status: text,
                        section: {
                            text: 'View',
                            translate: "viewBtn",
                            route: route.admin.school.section.view + '/' + data.id,
                        },
                        action: {
                            text: 'Edit',
                            translate: "EditBtn",
                            route: route.admin.school.classes.edit + '/' + data.id,
                        },
                    }
                    dataList.push(data)
                    classes.push(tableData)
                })
            }
            this.setState({
                data: dataList,
                classes,
            })
        })
    }
}

export function mapStateToProps(state: Object) {
    return {
        token: state.token,
    }
}
